/**
 * Pre-bundled Highcharts package with all required modules
 * Using this approach ensures all modules are initialized in the correct order
 */
import Highcharts from "highcharts/highstock";

import "highcharts/modules/no-data-to-display";
import "highcharts/modules/accessibility";
import "highcharts/highcharts-more";

try {
    Highcharts.setOptions({
        lang: {
            noData: "No chart data available",
        },
        noData: {
            style: {
                fontWeight: "normal",
                fontSize: "12px",
                color: "#707070",
            },
            position: {
                align: "center",
                verticalAlign: "middle",
            },
            useHTML: true,
        },
    });
} catch (e) {
    console.error("Failed to initialize Highcharts modules:", e);
}

export default Highcharts;
